<template>
  <div v-if="blok.quotes.length > 0" class="content-testimonials">
    <ul class="content-testimonials__quotes">
      <li
        v-for="(quote, index) in quotes"
        v-show="index === currentIndex"
        :key="quote._uid"
        class="content-testimonials__quote"
      >
        <BaseStoryblokRichText v-if="quote.text" :doc="quote.text" />
        <p class="content-testimonials__author">
          <SbAvatar
            show-name
            size="large"
            :src="quote.image?.filename"
            tooltip-variant="dark"
            :use-tooltip="false"
          />
          {{ quote.name }}, {{ quote.job }}
        </p>
      </li>
    </ul>
    <SbIconButton
      icon="drawn-arrow-left"
      :icon-filled="false"
      :is-clear="false"
      is-rounded
      :label="$t('Previous quote')"
      size="normal"
      variant="secondary"
      class="content-testimonials__arrow content-testimonials__arrow--left"
      @click="showPrevQuote"
    />
    <SbIconButton
      icon="drawn-arrow-right"
      :icon-filled="false"
      :is-clear="false"
      is-rounded
      :label="$t('Next quote')"
      size="normal"
      variant="secondary"
      class="content-testimonials__arrow content-testimonials__arrow--right"
      @click="showNextQuote"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { type Quote } from '@/types/quote'
import { SbAvatar, SbIconButton } from '@storyblok/design-system'
import BaseStoryblokRichText from '@/components/Base/BaseStoryblokRichText/BaseStoryblokRichText.vue'

const props = defineProps<{
  blok: {
    quotes: {
      content: Quote
    }[]
  }
  title: string
  id: string
}>()

const currentIndex = ref(0)

const quotes = computed((): Quote[] =>
  props.blok.quotes.map((quote) => quote.content),
)

const showPrevQuote = (): void => {
  currentIndex.value =
    currentIndex.value === 0 ? quotes.value.length - 1 : currentIndex.value - 1
}

const showNextQuote = (): void => {
  currentIndex.value =
    currentIndex.value === quotes.value.length - 1 ? 0 : currentIndex.value + 1
}
</script>

<style lang="scss" src="./content-testimonials.scss"></style>
